import { render, staticRenderFns } from "./TuitionDiscountRequests.vue?vue&type=template&id=aac89226&"
import script from "./TuitionDiscountRequests.vue?vue&type=script&lang=js&"
export * from "./TuitionDiscountRequests.vue?vue&type=script&lang=js&"
import style0 from "./TuitionDiscountRequests.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports